export * from './FoodDrinkAlcoGlassBeerIcon';
export * from './FoodDrinkAlcoGlassBeerIcon16Light';
export * from './FoodDrinkAlcoGlassBeerIcon16Regular';
export * from './FoodDrinkAlcoGlassBeerIcon16Solid';
export * from './FoodDrinkAlcoGlassBeerIcon20Light';
export * from './FoodDrinkAlcoGlassBeerIcon20Regular';
export * from './FoodDrinkAlcoGlassBeerIcon20Solid';
export * from './FoodDrinkAlcoGlassBeerIcon24Regular';
export * from './FoodDrinkAlcoGlassBeerIcon24Solid';
export * from './FoodDrinkAlcoGlassBeerIcon32Regular';
export * from './FoodDrinkAlcoGlassBeerIcon64Regular';
